export default {
  isVisible: false,
  content: null,
  status: null
};



// WEBPACK FOOTER //
// ./src/store/modules/promptXmas/state.js